import {
  AUTHENTICATING,
  AUTHENTICATED,
  UNAUTHENTICATED,
  AUTHENTICATION_ERROR,
} from "../actions/authActions";

export default function AuthReducer(
  state = {
    auth: {
      token: null,
      refresh_token: null,
      code: null,
      message: null,
      exp: null,
      email: null,
      roles: null,
      error: null,
      isLoggingIn: false,
    },
    authenticated: false,
  },
  action
) {
  switch (action.type) {
    case AUTHENTICATING:
      return { ...state, auth: action.payload, isLoggingIn: true };
    case AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
        auth: action.payload,
        isLoggingIn: false,
      };
    case UNAUTHENTICATED:
      return {
        ...state,
        authenticated: false,
        auth: {
          token: null,
          refresh_token: null,
          code: null,
          message: null,
          exp: null,
          email: null,
          roles: null,
          error: null,
          isLoggingIn: false,
        },
      };
    case AUTHENTICATION_ERROR:
      return { ...state, auth: action.payload, isLoggingIn: false };
    default:
      return state;
  }
}
